import { BiSave } from "react-icons/bi";
import { Errors, Touched } from "./inputs/utils";
import { RiSkipForwardLine } from "react-icons/ri";
import { usePermissions } from "@app/hooks";
import ModuleButton from "@components/button/ModuleButton";
import FooterError from "./FooterError";
import Button from "@components/button/Button";
import Spinner from "@components/spinner/Spinner";

interface ModuleFooterProps {
  footerError: string | undefined;
  errors: Errors;
  touched: Touched;
  isLoading: boolean;
  isDisabled: boolean;
  handleSaveAndProceed: () => void;
  handleNext: () => void;
  closingNotes?: string;
}

const ModuleFooter = ({ footerError, errors, touched, isLoading, isDisabled, handleSaveAndProceed, handleNext, closingNotes }: ModuleFooterProps) => {
  const { isReadOnly } = usePermissions();

  return (
    <footer className="module-group-footer">
      <div className="module-group">
        {closingNotes ? (<span className="ff-light fs-12 pb-2">{closingNotes}</span>) : null}

        <FooterError
          footerError={footerError}
          errors={errors}
          touched={touched}
        />

        <div className="d-flex gap-8">
          {!isReadOnly ? <Button type="submit" className={`br-8 bg-quat-br ${isLoading ? "op-8" : "px-1"}`} disabled={isLoading}>
            {isLoading ?
              <Spinner size={36} padding="0.5rem" /> :
              <BiSave size={20} color="var(--white)" />}
          </Button> : null}
          {!isReadOnly ? <ModuleButton
            buttonType="submit"
            disabled={isDisabled || isLoading}
            isLoading={isLoading}
            handleClick={handleSaveAndProceed}
            labelKey="main.save_module_and_proceed"
          /> : null}
          <ModuleButton icon={RiSkipForwardLine} buttonType="button" handleClick={handleNext} labelKey="main.skip_module" styleType="secondary" />
        </div>
      </div>
    </footer>
  );
}

export default ModuleFooter;